import { selectTopologyPresetModified } from 'components/Graph/GraphSidePanel/selectors/selectTopologyPresetModified';
import type { GraphSidePanelData } from 'components/Graph/GraphSidePanelData';
import type { GraphState } from 'components/Graph/GraphState';

export const shouldShowLeavingDialog = (
  state: GraphState,
  nextSidePanelState?: GraphSidePanelData,
): boolean => {
  const changingVisualizationSetupTab =
    nextSidePanelState &&
    nextSidePanelState.networkViewerTabId === 'visualizationSetup' &&
    nextSidePanelState.contentId === 'networkViewer';

  if (
    state.sidePanel.networkViewerTabId === 'visualizationSetup' &&
    selectTopologyPresetModified(state) &&
    state.layoutSettings.presetEditMode &&
    !changingVisualizationSetupTab
  ) {
    return true;
  }

  return false;
};
